import { RefDate, RefString, RefNumber, Collection } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { PackageToCustomerStepRawData } from "./PackageToCustomerStepRawData";
import { PackageToCustomerStepState } from "./PackageToCustomerStepState";


export class PackageToCustomerStepData extends StepData
{
    public PackageContent = new Collection<string>();
    public PlannedDispatchTime = new RefDate(new Date(0));
    public DispatchTime = new RefDate(new Date(0));
    public LastStatusCheckTime = new RefDate(new Date(0));
    public AddressFullInfo = new RefString();
    public PackageNumber = new RefString();
    public Carrier = new RefString("Pocztex");
    public PaymentAtDelivery = new RefNumber();
    public PackageCost = new RefNumber();

    constructor(raw: Partial<PackageToCustomerStepRawData>)
    {
        super(raw);

        this.State.value ||= PackageToCustomerStepState.NotPlannedYet;

        this.PackageContent.Load(...raw?.PackageContent || []);
        this.PlannedDispatchTime.value = new Date(raw?.PlannedDispatchTime || 0);
        this.DispatchTime.value = new Date(raw?.DispatchTime || 0);
        this.LastStatusCheckTime.value = new Date(raw?.LastStatusCheckTime || 0);
        this.AddressFullInfo.value = raw?.AddressFullInfo || "";
        this.PackageNumber.value = raw?.PackageNumber || "";
        this.Carrier.value = raw?.Carrier || "Pocztex";
        this.PaymentAtDelivery.value = raw?.PaymentAtDelivery || 0;
        this.PackageCost.value = raw?.PackageCost || 0;
    }
}
